import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Name",
  "Folder Id",
  "Actions",
];

const FarmTraningFolder = ({ data = [] }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-farm-tranig-details/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            return (
              <tr key={item?.id}>
                <td>{index + 1}</td>
                <td>
                {item?.name || "N/A"}
                </td>
              
                <td>{item?.id || "N/A"}</td>
        
               
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FarmTraningFolder;
